import styled from 'styled-components';

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top:0;
  top:0;
  position:absolute;
  padding-left: 70px;
  padding-right: 70px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background:#fff;
  height:75px;
`;

export { Container };
